import { fetcher } from '@commenda/utils';

import { TCreateBillingCountryPackParams } from './types';

export const createBillingCountryPack = async (params: TCreateBillingCountryPackParams) => {
  const response = await fetcher('commenda-billing/catalog/packs', {
    method: 'POST',
    body: params,
  });

  return response;
};
